import { Emitter } from "strict-event-emitter";
import { ScrollListener } from "./sframe/ScrollListener";
import ViewportRoot from "./sframe/ViewportRoot";

let _idCount = 0;

export class AutoLoadMark{

  $root: JQuery;

  private _isActive: boolean = false;

  private _id: string;

  private _thehold: number;

  emitter: Emitter<{trigger: []}>

  constructor(thehold: number = 200)
  {
    // console.log(thehold);
    
    this._thehold = thehold;

    this.emitter = new Emitter();

    _idCount++;
    this._id = "auto-load-mark-" + _idCount;

    this.$root = $(`<div id="${this._id}"></div>`);
  }

  toggle(b: boolean)
  { 
    if(this._isActive === b) return;
    this._isActive = b;
    
    if(this._isActive)
    {
      // throw new Error("toggle true"); 

      ScrollListener.addListener(this._id, ()=>
      { 
        this._test();
      });

      this._test();
    }
    else
    {
      ScrollListener.removeListener(this._id);
    }
  }

  _test()
  {

    console.log("auto load mark checking...");
        
    let bound = this.$root[0].getBoundingClientRect(),
      dy = bound.top - ViewportRoot.height,
      isInside = dy <= this._thehold;

    if(isInside) this.emitter.emit("trigger");       
  }
}